module.exports = __webpack_public_path__ + "static/media/MiniAdd.5ed35d9d.svg";